//react
import React from 'react';

//redux
import { connect } from 'react-redux';

//firebase
import { db, storage } from 'assets/firebase';

//styles
import withStyles from "@material-ui/core/styles/withStyles";
import modalStyle from "assets/jss/material-kit-react/modalStyle.jsx";

//core
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";

//components
import CustomTabs from "components/CustomTabs/CustomTabs.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import CustomSelect from "components/Select/Select.jsx";
import Button from "components/CustomButtons/Button.jsx";

// @material-ui/icons
import Edit from "@material-ui/icons/Edit";
import Attachment from "@material-ui/icons/AttachFile";

//fileUploader
import FileUploader from 'react-firebase-file-uploader';

//google Analytics
import ReactGA from 'react-ga';
ReactGA.initialize('UA-127392840-1');

function Transition(props) {
    return <Slide direction="down" {...props} />;
}
  
  class MaterialEditor extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        modal: false,
        material: { 
          Name: "",
          Description: "",
          Type: "general",
          URL:"",
          Quarter: 1,
          IsVisible: false
        }
      };

      this.saveMaterial = this.saveMaterial.bind(this);
      this.updateMaterial = this.updateMaterial.bind(this);
    }

    handleClickOpen(modal) {

      var material = this.props.material;

      if(!material.Type)
        material.Type = "General";

      this.setState({material: material});

      var x = [];
      x[modal] = true;
      this.setState(x);
    }

    handleClose(modal) {
      var x = [];
      x[modal] = false;
      this.setState(x);
    }

    updateMaterial(property, value) {
      var obj = this.state.material;
      obj[property] = value;
      this.setState({material: obj});
    }

    saveMaterial() {

      var obj = this.state.material;

      db.updateMaterial(obj.id, obj).then(doc => {
        
        if(!obj.id) { // i.e. if it's a new material

          obj.id = doc.id;
          
          this.props.onNew(obj);

          ReactGA.event({
            category: 'Support Material',
            action: 'Created New Support Material'
          });

          // reset to blank
          this.setState({material:{
            Name: "",
            Description: "",
            URL:"",
            Quarter: 0,
            Type: "General",
            orgId: this.props.org.id,
            IsVisible: false
          }});

        } else { // i.e. existing support material

          this.props.onChange(this.state.material);

          ReactGA.event({
            category: 'Support Material',
            action: 'Updated Support Material'
          });
        }
      });
    }


    attachmentUploadStart = () => this.setState({isUploading: true, progress: 0});
    attachmentUploadProgress = (progress) => this.setState({progress});
    attachmentUploadError = (error) => {
        this.setState({isUploading: false});
        console.error(error);
    }
    attachmentUploadSuccess = (filename) => {
        this.setState({progress: 100, isUploading: false});
        
        this.updateMaterial('FileName', filename);
        storage.downloads.child(filename).getDownloadURL().then(url => this.updateMaterial('URL', url));
    };

    showUpload() {
        if(this.state.material.URL)
            return "hidden";
        else
            return "visible";
    }

    trim(value, maxLength) {
      if(value.length > maxLength)
          return value.substring(0,maxLength) + "...";
      else
          return value;
    }

    render() {

      const { classes } = this.props;

      return (
        <div>
          
          <IconButton
            aria-label="Edit"
            onClick={() => this.handleClickOpen("modal")}>
            <Edit className={ classes.tableActionButtonIcon + " " + classes.edit } />
          </IconButton>
          <Dialog
            classes={{
              root: classes.center,
              paper: classes.modal
            }}
            open={this.state.modal}
            TransitionComponent={Transition}
            keepMounted
            maxWidth="md"
            onClose={() => this.handleClose("modal")}
            aria-labelledby="modal-slide-title"
            aria-describedby="modal-slide-description">

            <DialogTitle
              id="classic-modal-slide-title"
              disableTypography
              className={classes.modalHeader}
              style={{backgroundColor:"#efefef"}} >

              <GridContainer direction="row">
                <GridItem xs={12} sm={12} md={6}>
                  <h4 className={classes.modalTitle}>Edit Support Material</h4>
                </GridItem>
                <GridItem xs={12} sm={12} md={6} style={{textAlign:"right"}}>
                  
                </GridItem>
              </GridContainer>
            </DialogTitle>
            <DialogContent
              id="modal-slide-description"
              className={classes.modalBody}
              style={{backgroundColor:"#efefef"}}>
             <CustomTabs
                headerColor="success"
                tabs={[
                  {
                    tabName: "General",
                    tabIcon: Attachment,
                    tabContent: (
                      
                        <GridContainer direction="row">
                          <GridItem xs={12} sm={12} md={12}>
                            <CustomInput
                              id="Name"
                              labelText="Name"
                              value={this.state.material.Name}
                              inputProps={{
                                  placeholder: "Name"
                              }}
                              formControlProps={{
                                  fullWidth: true
                              }}
                              onChange={(e) => this.updateMaterial("Name", e.target.value)}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6}>
                            <CustomSelect
                                labelText="Type"
                                value={this.state.material.Type}
                                inputProps={{
                                    placeholder: "Type"
                                }}
                                formControlProps={{
                                    fullWidth: true
                                }}
                                onChange={(e) => this.updateMaterial("Type", e.target.value)}
                                options={[ {key:"activities", label:"Activities" }, {key:"assessments", label:"Assessments" }, {key:"general", label:"General" }, {key:"goals", label:"Goals" }, { key:"posters", label:"Posters" }, { key:"slides", label:"Slides" }, { key:"teams", label:"TEAMS" } ]}
                              />
                          </GridItem>
                          
                          <GridItem xs={12} sm={12} md={6}>
                              <CustomSelect
                                id="quarter"
                                labelText="Quarter"
                                value={this.state.material.Quarter}
                                inputProps={{
                                    placeholder: "Quarter"
                                }}
                                formControlProps={{
                                    fullWidth: true
                                }}
                                onChange={(e) => this.updateMaterial("Quarter", e.target.value)}
                                options={[
                                  {key:0,label:"n/a"},
                                  {key:1,label:"1"},
                                  {key:2,label:"2"},
                                  {key:3,label:"3"},
                                  {key:4,label:"4"}
                                ]}
                               />
                          </GridItem>

                            <GridItem xs={12} sm={12} style={{visibility:this.showUpload()}}>
                                <label style={{color: "#696969", cursor:"pointer", marginTop:"23px"}}>
                                    Upload a New File  
                                
                                    <FileUploader
                                        hidden 
                                        name="attachment"
                                        randomizeFilename
                                        storageRef={storage.downloads}
                                        onUploadStart={this.attachmentUploadStart}
                                        onUploadError={this.attachmentUploadError}
                                        onUploadSuccess={this.attachmentUploadSuccess}
                                        onProgress={this.attachmentUploadProgress}
                                    />
                                    
                                </label>
                            </GridItem>

                          <GridItem xs={12} sm={12} md={12} style={{display:"none"}}>
                            <CustomInput
                              id="URL"
                              labelText="URL"
                              value={this.state.material.URL}
                              inputProps={{
                                  placeholder: "URL"
                              }}
                              formControlProps={{
                                  fullWidth: true
                              }}
                              onChange={(e) => this.updateMaterial("URL", e.target.value)}
                            />
                          </GridItem>
                        </GridContainer>
                    )
                  }
                ]}
              />

            </DialogContent>
            
            <DialogActions
              className={classes.modalFooter }
              style={{backgroundColor:"#efefef"}}>
                <FormControlLabel
                    control={
                      <Switch
                        checked={this.state.material.IsVisible}
                        onChange={(e) => this.updateMaterial("IsVisible", e.target.checked)}
                        classes={{
                          switchBase: classes.switchBase,
                          checked: classes.switchChecked,
                          icon: classes.switchIcon,
                          iconChecked: classes.switchIconChecked,
                          bar: classes.switchBar
                        }}
                      />
                    }
                    classes={{
                      label: classes.label
                    }}
                    label="Visible"
                />
                <Button
                    onClick={() => this.handleClose("modal")}
                >
                Cancel
                </Button>
                &nbsp;
                <Button
                    onClick={() => {
                        this.saveMaterial();
                        this.handleClose("modal");
                        }}
                    color="success">
                    Save
                </Button>
            </DialogActions>
          </Dialog>
        </div>
      );
    }
  }
  
const mapStateToProps = state => {
  return state;
}

MaterialEditor = connect(mapStateToProps)(MaterialEditor);
export default withStyles(modalStyle)(MaterialEditor);


// WEBPACK FOOTER //
// ./src/components/MaterialEditor/MaterialEditor.jsx